import Swiper, { Navigation, Thumbs, Pagination } from "swiper";
export default function sliders(){
    Swiper.use(Navigation)
    Swiper.use(Thumbs)
    Swiper.use(Pagination)
    let slidesPerView1 = (document.querySelector('.js-scores-cards-slider')?.clientWidth/(285 + 10.25));
    let slidesPerView2 = (document.querySelector('.js-catalog-slider')?.clientWidth/(245 + 4));
    let howto = new Swiper('.js-scores-cards-slider', {
        wrapperClass: 'js-scores-cards-wrapper',
        slideClass: 'js-scores-cards-slide',
        slidesPerGroup: 1,
        slidesPerView: slidesPerView1,
        spaceBetween: 15
    }),
    catalog = new Swiper('.js-catalog-slider', {
        wrapperClass: 'js-catalog-wrapper',
        slideClass: 'js-catalog-slide',
        slidesPerGroup: 1,
        slidesPerView: slidesPerView2,
        spaceBetween: 12.62
    }),
    catalogDetailsThumbs = new Swiper('.js-catalog-thumbs', {
        direction: "vertical",
        wrapperClass: 'js-catalog-thumbs__wrapper',
        slideClass: 'js-catalog-thumbs__slide',
        slidesPerView: 4,
        spaceBetween: 20,
    }),
    catalogDetails = new Swiper('.js-catalog-slider', {
        wrapperClass: 'js-catalog-slider__wrapper',
        slideClass: 'js-catalog-slider__slide',
        sliderPerView: 1,
        spaceBetween: 10,
        navigation: {
            prevEl: '.js-catalog-slider-prev',
            nextEl: '.js-catalog-slider-next'
        },
        pagination: {
            type: 'bullets',
            el: '.js-catalog-slider__pagination',
            bulletClass: 'catalog-details__slider-pagination-bullet',
            bulletActiveClass: 'catalog-details__slider-pagination-bullet--active'
        },
        thumbs: catalogDetailsThumbs?.$el ? {
            swiper: catalogDetailsThumbs,
            slideThumbActiveClass: 'catalog-details__thumbs-slide--active',
        } : false,
        on: {
            beforeInit: ()=>{
            },
            slideChange: (swiper)=>{
                swiper.thumbs.swiper.slideTo(swiper.activeIndex)
            }
        }
    })
}